module.exports = __webpack_public_path__ + "static/media/Arrow-Left 2.0395f1a9.svg";